const BASE_PUBLIC_URL = `${process.env.PUBLIC_URL}`;
export const LOGO_IMG = BASE_PUBLIC_URL + "/img/logo2.png";
export const USERICON = BASE_PUBLIC_URL + "/img/usericon.svg";
export const LOACKICON = BASE_PUBLIC_URL + "/img/loackicon.svg";
export const HOMEICON = BASE_PUBLIC_URL + "/img/homeicon.svg";
export const EMPLOYEEICON = BASE_PUBLIC_URL + "/img/employeesicon.svg";
export const ASSEMENTICON = BASE_PUBLIC_URL + "/img/assementicon.svg";
export const RESULTICON = BASE_PUBLIC_URL + "/img/resulticon.svg";
export const SETTINGICON = BASE_PUBLIC_URL + "/img/settingicon.svg";
export const LOGOUTICON = BASE_PUBLIC_URL + "/img/logouticon.svg";
export const ACTIONARROW_ICON = BASE_PUBLIC_URL + "/img/actionArrowIcon.svg";
export const ROLEICON = BASE_PUBLIC_URL + "/img/loackicon.svg";
export const FRAMEIMG = BASE_PUBLIC_URL + "/img/Frameimg.png";
export const SETTING = BASE_PUBLIC_URL + "/img/settingicon.png";
export const BELLICON = BASE_PUBLIC_URL + "/img/bellicon.png";
export const SEARCHICON = BASE_PUBLIC_URL + "/img/searchicon.svg";
export const CUSTOMER_IMG = BASE_PUBLIC_URL + "/img/customer.png";
export const PROJECT_IMG = BASE_PUBLIC_URL + "/img/projectimg.png";
export const ASSEMENT_IMG = BASE_PUBLIC_URL + "/img/assesmentimg.png";
export const RIGHTARROW_ICON = BASE_PUBLIC_URL + "/img/rightarrowicon.svg";
export const EDIT_ICON = BASE_PUBLIC_URL + "/img/editicon.svg";
export const GREYEDIT_ICON = BASE_PUBLIC_URL + "/img/greyediticon.svg";
export const PLUS_ICON = BASE_PUBLIC_URL + "/img/plusicon.svg";
export const AVTAR_IMG = BASE_PUBLIC_URL + "/img/avtar_img.png"
export const ROLEEDIT_ICON = BASE_PUBLIC_URL + "/img/roleedit.svg"
export const STATUS_ICON = BASE_PUBLIC_URL + "/img/statusicon.svg"
export const GREYEYE_ICON = BASE_PUBLIC_URL + "/img/greyeyeicon.svg";
export const ADD_ICON = BASE_PUBLIC_URL + "/img/addicon.svg";
export const _ICON = BASE_PUBLIC_URL + "/img/roleedit.svg";
export const GREYEYE_INACTIVE_ICON = BASE_PUBLIC_URL + "/img/view-blue.svg";
export const BLUEEDIT_ICON = BASE_PUBLIC_URL + "/img/edit-blue.svg";
export const DASHBOARDGREY_ICON = BASE_PUBLIC_URL + "/img/dashboardgrey.svg";
export const ROLEACCESSGREY_ICON = BASE_PUBLIC_URL + "/img/roleaccessgrey.svg";
export const STAFFGREY_ICON = BASE_PUBLIC_URL + "/img/staffgrey.svg";
export const ASSESSMENTGREY_ICON = BASE_PUBLIC_URL + "/img/assessmentgrey.svg";
export const RESULTGREY_ICON = BASE_PUBLIC_URL + "/img/resultgrey.svg";
export const SETTINGSGREY_ICON = BASE_PUBLIC_URL + "/img/settingsgrey.svg";
export const CLOSE_ICON = BASE_PUBLIC_URL + "/img/close-icon.png";
export const GREYARROW_ICON = BASE_PUBLIC_URL + "/img/greyarrowicon.svg";
export const BLUEARROW_ICON = BASE_PUBLIC_URL + "/img/bluearrowicon.svg";
export const TOGGLELEFTARROW = BASE_PUBLIC_URL + "/img/toggleleft-arrow.png";
export const TOGGLERIGHTARROW = BASE_PUBLIC_URL + "/img/toggleright-arrow.png";
export const LOGO_COLLAPSED_IMG = BASE_PUBLIC_URL + "/img/caspera-shortlogo.png";
export const LOGO_ACCESSIMG_IMG = BASE_PUBLIC_URL + "/img/Access_img.png"
export const CLOSE_EYEICON = BASE_PUBLIC_URL + "/img/close_eyeicon.png"
export const OPEN_EYEICON = BASE_PUBLIC_URL + "/img/open_eyeicon.png"
export const LOGOUT_IMG = BASE_PUBLIC_URL + "/img/logoutimg.png"
export const BLUESTATUS_ICON = BASE_PUBLIC_URL + "/img/bluestatus.svg";
export const BLUEPLUSICON_ICON = BASE_PUBLIC_URL + "/img/blueplusicon.svg";
export const GREYPLUSICON_ICON = BASE_PUBLIC_URL + "/img/greyplusicon.svg";
export const GREYSTATUS_ICON = BASE_PUBLIC_URL + "/img/greystatus.svg";
export const CORPORATE_ICON = BASE_PUBLIC_URL + "/img/corporateicon.svg";
export const GREYEYE_ICONIMG = BASE_PUBLIC_URL + "/img/greyeyeicon.png"
export const BLUEEYE_ICONIMG = BASE_PUBLIC_URL + "/img/blueeyeicon.png"
export const BACKARROW_IMG = BASE_PUBLIC_URL + "/img/BackArrow.svg";
export const QUIZNEXT_IMG = BASE_PUBLIC_URL + "/img/quiznext.svg";
export const QUIZPREV_IMG = BASE_PUBLIC_URL + "/img/quizprev.svg";
export const WHITEBGDOWNARROW_IMG = BASE_PUBLIC_URL + "/img/whitebgdownarrow.svg";
export const RESULTPIECHART_IMG = BASE_PUBLIC_URL + "/img/result-piechart.svg";
export const DIMENTIONDETAILCHART_IMG = BASE_PUBLIC_URL + "/img/diemantiondetailchart.svg";
export const RESULTBARSHORIZONTALCHART_IMG = BASE_PUBLIC_URL + "/img/resultbarscharthorizontal.svg";
export const PROFILE_IMG = BASE_PUBLIC_URL + "/img/profile_image.png";
export const HEATMAP_IMG = BASE_PUBLIC_URL + "/img/Heatmap.png";
export const GAPCHART_IMG = BASE_PUBLIC_URL + "/img/gapchart.png";
export const DMMSUBDIAMENTIONCHART_IMG = BASE_PUBLIC_URL + "/img/subdimentionchart.png";
export const BENCHMARKCHART_IMG = BASE_PUBLIC_URL + "/img/benchmarkchart.png";
export const PARTICPANTSBARCHART_IMG = BASE_PUBLIC_URL + "/img/participantsbarchart.png";
export const DEMOGRAPHICCHART_IMG = BASE_PUBLIC_URL + "/img/demographicchart.png";
export const DEMOGRAPHICDIVISIONLEVELCHART_IMG = BASE_PUBLIC_URL + "/img/demogrphicdivisionlevelchart.png";
export const JOBLEVELBARCHART_IMG = BASE_PUBLIC_URL + "/img/joblevelbarchart.png";
export const DEMOGRAPHICJOBLEVELTABLE_IMG = BASE_PUBLIC_URL + "/img/demographicjobleveltable.png";
export const DEMOGRAPHICJOBLEVELSTEPCHART_IMG = BASE_PUBLIC_URL + "/img/demographicjoblevelstepchart.png";
export const PDFFILE_IMG = BASE_PUBLIC_URL + "/img/file-pdf.svg";
export const PROFILE_ICON = BASE_PUBLIC_URL + "/img/profileicon.svg";
export const SCORE_ICON = BASE_PUBLIC_URL + "/img/scoreicon.svg";
export const WHITENEXTARROW_ICON = BASE_PUBLIC_URL + "/img/whitenextarrow.svg";
export const FILE_UPLOAD_IMG = BASE_PUBLIC_URL + "/img/fileuploadicon.svg";
export const ADMIN_ICON = BASE_PUBLIC_URL + "/img/adminicon.svg";
export const SUCCESSICON = BASE_PUBLIC_URL + "/img/complete-bgicon.png"
export const TOOLTIPICON = BASE_PUBLIC_URL + "/img/tooltip-icon.svg";
export const CURRENTSCORE_ICON = BASE_PUBLIC_URL + "/img/currentscoreicon.png"
export const FUTURESCORE_ICON = BASE_PUBLIC_URL + "/img/futurescoreicon.png"
export const UPLOAD_ICON = BASE_PUBLIC_URL + "/img/uploadicon.png";
export const NOTIFYCANCEL_ICON = BASE_PUBLIC_URL + "/img/notify-Cancel.svg";
export const PDF_ICON = BASE_PUBLIC_URL + "/img/pdficon.png";
export const PPT_ICON = BASE_PUBLIC_URL + "/img/ppticon.png";
export const Image_ICON = BASE_PUBLIC_URL + "/img/imageicon.png";
export const DELETE_ICON = BASE_PUBLIC_URL + "/img/delete-Icon.svg";
export const DELETE_GIF = BASE_PUBLIC_URL + "/img/Delete_GIF.gif"
export const FILTER_ICON = BASE_PUBLIC_URL + "/img/filter.svg";
export const USERBACK_ICON = BASE_PUBLIC_URL + "/img/Back-Intro-btn.svg";
export const USERLOGOUT_ICON = BASE_PUBLIC_URL + "/img/UserLogout-btn.svg";
export const MENU_ICON = BASE_PUBLIC_URL + "/img/menuicon.svg"
export const CHAT_ICON = BASE_PUBLIC_URL + "/img/chaticon.svg"
export const ZOOM_ICON = BASE_PUBLIC_URL + "/img/zoomicon.svg"








